import { useState, useEffect } from 'react';
import { CheckCircle } from 'lucide-react';

interface TransformerImageProps {
  src: string;
  alt: string;
  width: number;
  height: number;
  className?: string;
}

export const TransformerImage: React.FC<TransformerImageProps> = ({
  src,
  alt,
  width,
  height,
  className = ''
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = src;
    img.onload = () => setIsLoaded(true);
    img.onerror = () => setError(true);
  }, [src]);

  if (error) {
    return (
      <div className="flex items-center justify-center bg-gray-100 rounded-lg p-4">
        <CheckCircle className="h-8 w-8 text-gray-400" />
        <span className="ml-2 text-gray-500">Изображение недоступно</span>
      </div>
    );
  }

  return (
    <div className="relative">
      {!isLoaded && (
        <div className="absolute inset-0 bg-gray-200 animate-pulse rounded-lg" />
      )}
      <img
        src={src}
        alt={alt}
        width={width}
        height={height}
        loading="lazy"
        onLoad={() => setIsLoaded(true)}
        className={`transition-opacity duration-300 rounded-lg ${
          isLoaded ? 'opacity-100' : 'opacity-0'
        } ${className}`}
      />
    </div>
  );
}; 